'use client';

import { ReactNode } from 'react';
import { clsx } from 'clsx';

import { Link } from '@northladder/i18n';

/**
 * A string representing the button's variant, which can be 'primary',
 * 'secondary', or 'tertiary'.
 */
// type TButtonVariant = 'primary' | 'secondary' | 'tertiary';

interface INavButtonProps {
  /**
   * The content to be displayed inside the button.
   */
  children: ReactNode;
  /**
   * An optional string representing additional CSS classes to be applied to
   * the button.
   */
  className?: string;
  /**
   * This is still a work in progress. Updating this to allow buttons to be used as
   * NavLink components (`a`) tags that are styled as buttons.
   * TODO: @Sowed Come up with a better structure for this.
   */
  href: string;
  /**
   * The html title attribute/tooltip text that is shown when hovering over the
   * button.
   */
  title?: string;
  // /**
  //  * A string representing the button's variant, which can be 'primary',
  //  * 'secondary', or 'tertiary'.
  //  */
  // variant?: TButtonVariant;
}

/**
 * -----------------------------------------------------------------------------
 * This is a temporary link that is styled as a button. It is used for navigation
 * and will be improved upon later.
 *
 * TODO: @Sowed clean up & update this later for a better component API.
 */
export function NavButton({
  children,
  className,
  href,
  title,
}: // variant,
Readonly<INavButtonProps>) {
  return (
    <Link
      className={clsx(
        `
          inline-flex items-center rounded-full bg-white px-8 py-1.5 text-sm
          font-semibold text-gray-950 transition hover:bg-gray-200
        `,
        className
        // variant === 'primary' && 'primary-btn',
        // variant === 'secondary' && 'secondary-btn',
        // variant === 'tertiary' && 'tertiary-btn'
      )}
      href={href}
      title={title}
    >
      <span className={clsx('relative top-px', className)}>{children}</span>
    </Link>
  );
}
